<template>
    <div>
        <v-dialog max-width="1200px" v-model="dialog" persistent>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title style="padding-left: 0px">
                        Đề nghị sửa chữa
                    </v-toolbar-title>
                </v-toolbar>
                <v-btn
                    @click="close"
                    icon
                    style="position: absolute; right: 10px; top: 10px; color: #fff"
                >
                    <v-icon>cancel</v-icon>
                </v-btn>
                <v-card-text>
                    <v-layout wrap style="padding: 10px;">
                        <v-flex xs12 sm12 md6>
                            <p class="font-weight-bold">
                                Số đề nghị:
                                {{ createItem.repairRequestCode }}
                            </p>
                            <p class="font-weight-bold">
                                Mã quản lý:
                                {{ fixedAssetsCode }}
                            </p>
                            <p class="font-weight-bold">
                                Tên tài sản:
                                {{ fixedAssetsName }}
                            </p>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <p class="font-weight-bold">
                                Bộ phận sử dụng hiện tại:
                                {{ departmentName }}
                            </p>
                            <p class="font-weight-bold">
                                Địa điểm sử dụng hiện tại:
                                {{ locationName }}
                            </p>
                            <p class="font-weight-bold">
                                Tình trạng sau sửa chữa gần nhất:
                                
                            </p>
                            <p class="font-weight-bold" v-if="this.createItem.repairRequestId != undefined && this.createItem.repairRequestId != null">
                                Ghi chú:
                                {{ createItem.reason }}
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text>
                    <table class="lstTable">
                        <tr>
                            <th width="20%">Ngày dự kiến xuất kho đi sửa</th>
                            <th width="20%">Ngày nhập kho dự kiến</th>
                            <th width="20%">Đơn vị sửa chữa</th>
                            <th width="20%">Chi phí sửa chữa dự kiến</th>
                            <th width="20%">Nội dung sửa chữa</th>
                        </tr>
                        <tr>
                            <td style="text-align:center">
                                <i-datepicker 
                                    v-model="createItem.expectedDateExport"
                                    v-if="showUpdate"
                                />
                                <template v-else>{{ createItem.expectedDateExport }}</template>
                            </td>
                            <td style="text-align:center">
                                <i-datepicker 
                                    v-model="createItem.expectedDateImport"
                                    v-if="showUpdate"
                                />
                                <template v-else>{{ createItem.expectedDateImport }}</template>
                            </td>
                            <td style="text-align:center">
                                <v-autocomplete
                                    :items="lstSupplier"
                                    v-model="createItem.repairUnitId"
                                    item-value="partnerId"
                                    item-text="partnerName"
                                    v-if="showUpdate"
                                />
                                <template v-else>{{ this.repairUnitName }}</template>
                            </td>
                            <td style="text-align:center">
                                <v-text-field
                                    type="number"
                                    v-model.trim="createItem.expectedCost"
                                    maxLength="250"
                                    v-if="showUpdate"
                                ></v-text-field>
                                <template v-else>{{ createItem.expectedCost }}</template>
                            </td>
                            <td style="text-align:center">
                                <v-text-field
                                    type="text"
                                    v-model.trim="createItem.repairContent"
                                    maxLength="250"
                                    v-if="showUpdate"
                                ></v-text-field>
                                <template v-else>{{ createItem.repairContent }}</template>
                            </td>
                        </tr>
                    </table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="historyDlg=true" v-if="this.createItem.repairRequestId != undefined && this.createItem.repairRequestId != null">
                        {{ $t("lang.common.history") }}
                    </v-btn>
                    <v-btn v-if="showUpdate" color="success" @click="onSave" :disabled="loading">
                        {{ saveText }}
                    </v-btn>
                    <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
                        {{ $t("Phê duyệt") }}
                    </v-btn>
                    <v-btn v-if="showReject" color="error" @click="openDialogReject" :disabled="loading">
                        {{ $t("Không phê duyệt") }}
                    </v-btn>
                    <v-btn v-if="showExport" color="success" @click="onExport" :disabled="loading">
                        Xuất kho
                    </v-btn>
                    <v-btn v-if="showCreateImport" color="success" @click="onCreateImport" :disabled="loading">
                        Tạo phiếu nhập kho
                    </v-btn>
                    <v-btn v-if="showImport" color="success" @click="onImport" :disabled="loading">
                        Nhập kho
                    </v-btn>
                    <v-btn v-if="showDelete" color="error" @click="openDialogDelete" :disabled="loading">
                        {{ $t("lang.common.delete") }}
                    </v-btn>
                    <v-btn v-if="showCancel" color="error" @click="openDialogCancel" :disabled="loading">
                        {{ $t("lang.common.cancel") }}
                    </v-btn>
                    <v-btn color="warning" @click="close">
                        {{ $t("lang.common.close") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="historyDlg" width="800px" persistent>
            <v-form data-vv-name="historyForm">
                <v-card>
                    <div class="headline dialog-header">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title style="padding-left: 10px">
                            Lịch sử
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-btn
                            @click="historyDlg=false"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                        >
                            <v-icon>cancel</v-icon>
                        </v-btn>
                    </div>
                    <v-card-text>
                        <table class="lstTable" v-if="lstHistory.length>0">
                            <tr>
                                <th width="20%">Thời gian</th>
                                <th width="15%">Người xử lý</th>
                                <th width="15%">Xử lý</th>
                                <th width="50%">Nội dung</th>
                            </tr>
                            <tr v-for="item in lstHistory">
                                <td>{{item.actionTime|formatDateTime}}</td>
                                <td><label style="font-weight: bold;color:blue">{{item.userName}}</label></td>
                                <td>{{item.action}}</td>
                                <td><label v-if="item.actionContent"> {{item.actionContent}}</label></td>
                            </tr>
                        </table>
                        <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn @click="historyDlg=false">{{$t('lang.common.close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <repair-edit
            :propsItem="repairItem"
            :cDialog="repairCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :fixedAssetsId="fixedAssetsId"
            :lstSupplier="lstSupplier"
            isImport
        />
        <dialog-reject 
            :dialog="dialogRejectRequest"
            @close="closeDialogReject"
            @onReject="onReject"
        />
        <dialog-cancel 
            :dialog="dialogCancelRequest"
            @close="closeDialogCancel"
            @onCancel="onCancel"
        />
        <dialog-delete 
            :dialog="dialogDeleteRequest"
            @close="closeDialogDelete"
            @onDelete="onDelete"
        />
    </div>    
</template>

<script>

import { message } from "../../../services";
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import moment from "moment";
import {roleConstants, requestConstants} from "@/constants";
import RepairEdit from "./RepairEdit.vue";
import DialogReject from "./component/DialogReject.vue";
import DialogCancel from "./component/DialogCancel.vue";
import DialogDelete from "./component/DialogDelete.vue";

export default {
    name: "Repair-request-create",
    components: { CSearchForm, RepairEdit, DialogReject, DialogCancel, DialogDelete },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        propsItem: {
            type: Object,
            default: ()=> {}
        },
    },
    data: () => {
        return {
            loading: false,
            lstHistory: [],
            fixedAssetsName: '',
            fixedAssetsCode: '',
            locationName: '',
            departmentName: '',
            lstSupplier: [],
            saveText: 'Tạo phiếu',
            repairItem: null,
            repairCreateDialog: false,
            fixedAssetsId: 0,
            dialogCancelRequest: false,
            dialogRejectRequest: false,
            dialogDeleteRequest: false,
            historyDlg: false,
            repairUnitName: '',
            createItem: {
                repairRequestCode: '',
                fixedAssetsId: '',
                expectedDateExport: '', 
                expectedDateImport: '', 
                repairUnitId: '',  
                repairContent: '',
                expectedCost: 0,
                userCreateId: null,
                status: 1,
            },
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    if (value.repairRequestId != undefined) {
                        this.saveText = "Cập nhật";
                        // this.createItem = value;
                        this.createItem = {
                            conditionAfterRepair: value.conditionAfterRepair,
                            createdAt: value.createdAt,
                            expectedDateExport: value.expectedDateExport,
                            expectedDateImport: value.expectedDateImport,
                            fixedAssetsCode: value.fixedAssetsCode,
                            fixedAssetsName: value.fixedAssetsName,
                            reason: value.reason,
                            repairContent: value.repairContent,
                            repairRequestCode: value.repairRequestCode,
                            repairRequestId: value.repairRequestId,
                            repairUnitId: value.repairUnitId,
                            status: value.status ? value.status : 0,
                            userCreateId: value.userCreateId,
                            expectedCost: value.expectedCost,
                            fixedAssetsExported: value.fixedAssetsExported,
                        };
                        if (value.expectedDateExport != '' && value.expectedDateExport != null) {
                            this.createItem.expectedDateExport = moment(String(value.expectedDateExport)).format('YYYY-MM-DD')
                        }
                        if (value.expectedDateImport != '' && value.expectedDateImport != null) {
                            this.createItem.expectedDateImport = moment(String(value.expectedDateImport)).format('YYYY-MM-DD')
                        }

                        this.getSupplierName(this.createItem.repairUnitId);
                        this.getHistory(this.createItem);
                    } else {
                        this.getNextCode();
                        this.saveText = "Tạo phiếu";
                    }

                    if (value.fixedAssetsId != undefined && value.fixedAssetsId !== null) {
                        this.createItem.fixedAssetsId = value.fixedAssetsId;
                        this.getFixedAssets(this.createItem.fixedAssetsId);
                    } else {
                        this.resetForm();
                    }
                } else {
                    this.resetForm();
                }
            },
            deep: true,
        },
        fixedAssetsId: {
            handler(value) {
                
            },
            deep: true,
        },
        dialog: {
            handler(value) {
                if (value) {
                    this.loading = false;
                }
            },
            deep: true,
        },
    },
    created() {
        this.getSupplier();
        this.getNextCode();
    },
    computed: {
        showApprove() {
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showReject() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showExport () {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
                && this.createItem.status == requestConstants.repairRequestStatusCons.approved) {
                return true;
            } else {
                return false;
            }
        },
        showImport () {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
                && this.createItem.status == requestConstants.repairRequestStatusCons.waitImport) {
                return true;
            } else {
                return false;
            }
        },
        showCreateImport() {
            if (this.createItem.status == undefined) return false;
            if (this.createItem.userCreateId != null) {
                if (this.createItem.status == requestConstants.repairRequestStatusCons.exported
                    && this.$store.state.auth.user.userId == this.createItem.userCreateId) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.createItem.status == requestConstants.repairRequestStatusCons.exported) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        showUpdate() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.createItem.userCreateId != null) {
                if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT)
                    && (this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove
                    || this.createItem.status == requestConstants.repairRequestStatusCons.approved
                    || this.createItem.status == requestConstants.repairRequestStatusCons.exported)
                    && this.$store.state.auth.user.userId == this.createItem.userCreateId) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT)
                    && this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        showDelete() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT)
                && this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove
                && this.$store.state.auth.user.userId == this.createItem.userCreateId) {
                return true;
            } else {
                return false;
            }
        },
        showCancel() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.createItem.status == requestConstants.repairRequestStatusCons.approved) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        resetForm() {
            this.fixedAssetsName = '';
            this.fixedAssetsCode = '';
            this.locationName = '';
            this.departmentName = '';
            this.createItem = {
                repairRequestCode: '',
                fixedAssetsId: '',
                expectedDateExport: '', 
                expectedDateImport: '', 
                repairUnitId: '',  
                repairContent: '',
                status: 1,
            };
        },
        onSave: function () {
            // this.$validator.validate().then((valid) => {
            //     if (!valid) {
            //         message.error(this.$t("lang.common.validate_fail"));
            //         return;
            //     }
                this.loading = true;
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/repairRequest/save",
                        this.createItem
                    )
                    .then(
                        (data) => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.close();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            // });
        },
        onApprove() {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/repairRequest/updateStatus", 
                {repairRequestId: this.createItem.repairRequestId, status: requestConstants.repairRequestStatusCons.approved})
                .then(
                    (data) => {
                        if (data) {
                            message.success(this.$t("lang.common.save_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                    }
                );
        },
        // onReject() {
        //     this.loading = true;
        //     axios
        //         .post(process.env.VUE_APP_API_URL + "/repairRequest/updateStatus", 
        //         {repairRequestId: this.createItem.repairRequestId, status: requestConstants.repairRequestStatusCons.rejected})
        //         .then(
        //             (data) => {
        //                 if (data) {
        //                     message.success(this.$t("lang.common.save_success"));
        //                     this.close();
        //                 } else {
        //                     message.error(this.$t("lang.common.save_error"));
        //                 }
        //             }
        //         );
        // },
        onExport() {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/repairRequest/updateStatus", 
                {repairRequestId: this.createItem.repairRequestId, status: requestConstants.repairRequestStatusCons.exported})
                .then(
                    (data) => {
                        if (data) {
                            message.success(this.$t("lang.common.save_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                    }
                );
        },
        onImport() {
            // this.repairItem = this.createItem;
            // this.repairCreateDialog = true;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/repairRequest/updateStatus", 
                {repairRequestId: this.createItem.repairRequestId, status: requestConstants.repairRequestStatusCons.imported})
                .then(
                    (data) => {
                        if (data) {
                            message.success(this.$t("lang.common.save_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                    }
                );
        },
        onCreateImport() {
            this.repairItem = this.createItem;
            this.repairCreateDialog = true;
        },
        close(fixedAssetsId = null) {
            this.$emit("close", fixedAssetsId);
        },
        getHistory(createItem) {
            axios.post(
                process.env.VUE_APP_API_URL + "/repairRequest/searchHistory?repairRequestId=" + createItem.repairRequestId).then(
                (data) => {
                    this.lstHistory = data;
                }
            );
        },
        getFixedAssets(fixedAssetsId) {
            axios.post(process.env.VUE_APP_API_URL + "/fixedAssets/detailReport?pageSize=-1&page=-1", {fixedAssetsId: fixedAssetsId})
            .then(
                (data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        const item = data.items[0];
                        this.fixedAssetsName = item.name;
                        this.fixedAssetsCode = item.code;
                        this.locationName = item.locationName;
                        this.departmentName = item.departmentName;
                        
                        if (this.createItem.repairRequestId == undefined && item.supplierId != null && item.supplierId.length > 0) {
                            const supplierIdArray = item.supplierId.split(",");
                            this.createItem.repairUnitId = parseInt(supplierIdArray[0]);
                        }
                    }
                }
            );
        },
        getNextCode() {
            axios.get(
                process.env.VUE_APP_API_URL +
                "/autoIncrease/getNextCode?type=ĐNSC&prefix=ĐNSC&numberZeroBeforeCodeNumberCode=1&suffix="
            )
                .then((data) => {
                    this.createItem.repairRequestCode = data;
                });
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        getSupplier() {
            axios.post(
                process.env.VUE_APP_API_URL + "/partner/search?pageSize=-1&page=-1&orderBy=asc",
                 {typeId: 340}
            )
                .then(
                    (data) => {
                        if (data.items) {
                            this.lstSupplier = data.items;
                        }
                    }
                );
        },
        closeCreateDialog(fixedAssetsId = null) {
            this.repairItem = null;
            this.repairCreateDialog = false;
            if (parseInt(fixedAssetsId) > 0) {
                this.close(fixedAssetsId);
            }
        },
        getSupplierName(supplierId) {
            const partner = this.lstSupplier.find((v) => v.partnerId === supplierId);
            if (partner != undefined) {
                this.repairUnitName = partner.partnerName;
            }
        },
        openDialogCancel () {
            this.dialogCancelRequest = true;
        },
        closeDialogCancel() {
            this.dialogCancelRequest = false;
        },
        openDialogReject() {
            this.dialogRejectRequest = true;
        },
        closeDialogReject() {
            this.dialogRejectRequest = false;
        },
        openDialogDelete() {
            this.dialogDeleteRequest = true;
        },
        closeDialogDelete() {
            this.dialogDeleteRequest = false;
        },
        onReject(reason = '') {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/repairRequest/updateStatus", 
                {
                    repairRequestId: this.createItem.repairRequestId, 
                    status: requestConstants.repairRequestStatusCons.rejected,
                    reason: reason
                })
                .then(
                    (data) => {
                        this.closeDialogReject();
                        if (data) {
                            message.success(this.$t("lang.common.save_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    }
                );
        },
        onCancel(reason = '') {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/repairRequest/updateStatus", 
                {
                    repairRequestId: this.createItem.repairRequestId, 
                    status: requestConstants.repairRequestStatusCons.rejected,
                    reason: reason
                })
                .then(
                    (data) => {
                        this.closeDialogCancel();
                        if (data) {
                            message.success(this.$t("lang.common.save_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    }
                );
        },
        onDelete() {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/repairRequest/delete", 
                {repairRequestId: this.createItem.repairRequestId})
                .then(
                    (data) => {
                        this.closeDialogDelete();
                        if (data) {
                            message.success(this.$t("lang.common.delete_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.delete_error"));
                        }
                        this.loading = false;
                    }
                );
        },
    },
    destroyed() {},
};
</script>
